export const getImageUrl = (path) => {
  const baseUrl =
    process.env.VUE_APP_MODE === "development"
      ? process.env.VUE_APP_IMAGE_DEV_URL
      : process.env.VUE_APP_IMAGE_BASE_URL;
  if (!path) return "";
  return `${baseUrl}/${path.startsWith("/") ? path.slice(1) : path}`;
};

export default {
  getImageUrl,
};
